<template>
    <b-badge :class="hiddenClass">
        {{ hiddenText }}
    </b-badge>
</template>

<script>
    export default {
        name: 'BadgeHidden',
        props: {
            value: {
                type: [Number, Boolean],
                required: true,
            },
            labels: {
                type: Object,
                default: () => ({}),
            },
        },
        computed: {
            hiddenClass() {
                const value = this.value;
                if (value === 0) return 'badge-success';
                if (value === 1 || value === 2) return 'badge-danger';
                return 'badge-secondary';
            },
            hiddenText() {
                const value = this.value;

                if (this.labels[value]) {
                    return this.labels[value];
                }

                if (value === 0) return this.$t('hiddenEnum.not');
                if (value === 1) return this.$t('hiddenEnum.yes');
                if (value === 2) return this.$t('hiddenEnum.temporary');

                return `${this.$t('unknown')} (${value})`;
            },
        },
    };
</script>
